import { render } from "./Info.vue?vue&type=template&id=0a44039c&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=0a44039c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a44039c"

export default script